'use client';

import React, { DetailedHTMLProps } from 'react';
import PlayArrow from '../../../public/images/play_arrow.png';
import { PlayButtonArrow, PlayButtonWrapper } from './styles';

const PlayButton = (
    props: DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
) => {
    return (
        <PlayButtonWrapper {...props}>
            {/** TODO */}
            <svg>
                <circle></circle>
            </svg>
            <PlayButtonArrow src={PlayArrow} alt='PlayButton Arrow' />
        </PlayButtonWrapper>
    );
};

export { PlayButton };
